import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const Cursor = () => {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [label, setLabel] = useState("");
  const [hovering, setHovering] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(hover: none)").matches) return;
    const move = (e) => {
      setPos({ x: e.clientX, y: e.clientY });
      const target = e.target.closest("[data-cursor], a, button, input, textarea, select, label, [role='button']");
      if (target) {
        setHovering(true);
        setLabel(target.getAttribute("data-cursor") || "");
      } else {
        setHovering(false);
        setLabel("");
      }
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  if (typeof window !== "undefined" && window.matchMedia("(hover: none)").matches) return null;

  return (
    <motion.div
      className="fixed top-0 left-0 z-[100] pointer-events-none flex items-center justify-center"
      animate={{
        x: pos.x - (label ? 32 : hovering ? 24 : 14),
        y: pos.y - (label ? 32 : hovering ? 24 : 14),
        width: label ? 64 : hovering ? 48 : 28,
        height: label ? 64 : hovering ? 48 : 28,
      }}
      transition={{ type: "spring", stiffness: 500, damping: 35, mass: 0.4 }}
      style={{
        borderRadius: "50%",
        border: `1px solid ${label ? "#C1121F" : "#8B0000"}`,
        background: label ? "rgba(139,0,0,0.85)" : hovering ? "rgba(139,0,0,0.15)" : "transparent",
        backdropFilter: label ? "blur(2px)" : "none",
      }}
    >
      {label && <span className="text-[9px] font-bold tracking-widest text-[#EDEDEA]">{label}</span>}
    </motion.div>
  );
};
